import { IUser } from '../user/user';

export interface ILogEntry {
  id: number;
  entityId: number;
  entityType: string;
  message: string;
  userId: number;
  created: string;
  user: IUser;
}

export interface ICommentsRequestParams {
  entityId: number;
  entityType: string;
  page: number;
  size: number;
}

export interface ICommentParams {
  entityId: number;
  entityType: string;
  message: string;
  userId: number;
}

export interface IComment {
  id: number;
  entityId: number;
  entityType: string;
  message: string;
  userId: number;
  created: string;
  user?: IUser;
}

export enum LogEntryType {
  Hub = 'HUB',
  TransferCompany = 'TRANSFER_COMPANY',
  Partner = 'PARTNER',
  Journey = 'JOURNEY',
  Booking = 'BOOKING',
  JourneyOffering = 'JOURNEY_OFFERING',
  Invoice = 'INVOICE',
}

export interface IPageViewsParams {
  application: string;
  page: string;
  timeFrameInSeconds: number;
}

export interface IPageViewsPostParams {
  application: string;
  page: string;
}

export interface IPageViewUser {
  userName: string;
  recordedAt: string;
}
